// extracted by mini-css-extract-plugin
export default {"step-nav":"stepNav_step-nav__ypCRg","btn-nav":"stepNav_btn-nav__+RiOZ","btn-disabled":"stepNav_btn-disabled__qA-6X"};